class ChatLanguage {
    constructor(locale) {
        this.language = {};
        this.language['da-DK'] = {
            'F01': 'Dette er en betaudgave',
            'F02': 'Skriv besked her...',
            'F03': 'Tryk på ENTER for at sende besked',
            'F04': 'Forbindelsen er afbrudt<br>\nVent venligst.',
            'F05': 'Sidste besked modtaget:',
            'F06': 'skriver en besked',
            'F07': 'kom ind i rummet',
            'F08': 'forlod rummet',
            'F09': 'Brugerliste',
            'F10': 'Rumliste',
            'F100': 'Se alle venner',
            'F101': 'Søg i vennelisten...',
            'F102': 'Samtalelisten er tom',
            'F103': 'Tryk ENTER for at vælge',
            'F104': 'Vælg modtager',
            'F105': 'I går',
            'F106': 'Send',
            'F107': 'kl.',
            'F108': 'Nye beskeder',
            'F109': 'Er du sikker?',
            'F11': 'Indstillinger',
            'F110': 'Ok',
            'F111': 'Annuller',
            'F112': 'Søg',
            'F113': 'Start samtale med XX her',
            'F114': 'Slet',
            'F115': 'Notifikationer',
            'F116': 'Sig tillykke!',
            'F117': 'Tillykke! :-D',
            'F118': 'Tillykke og tak! :-D',
            'F119': 'Notifikationslisten er tom',
            'F12': 'Din ven',
            'F120': 'er ikke online',
            'F121': 'Bemærk! Spillet åbnes i dette spilvindue',
            'F122': 'Vil du slette disse meddelelser?',
            'F123': 'Lyde i chatten',
            'F124': 'Hvad skal rumnavnet være?',
            'F125': 'Invitér andre brugere ved at indtaste deres brugernavne, adskilt af mellemrum',
            'F126': 'Tilkald admin',
            'F127': 'Invitér andre til dette rum',
            'F128': 'En administrator er tilkaldt',
            'F129': 'Der er fejl i indtastningen. Prøv igen.',
            'F13': 'og',
            'F130': 'inviterer dig til dette chatrum',
            'F131': 'Opret gruppechat',
            'F132': 'Der er brug for en admin i',
            'F133': 'oprettet af dig',
            'F134': 'Du har muligvis problemer med din forbindelse, hvilket kan skyldes malware, eller lignende. Malware er computerprogrammer, der gør skadelige eller uønskede ting på de computere, de kører på. Kontakt kundeservice, hvis du har brug for hjælp til at fjerne det.',
            'F135': 'Gå til dette rum?',
            'F136': 'Start chat med XX?',
            'F137': 'test',
            'F138': 'er nu inviteret',
            'F139': 'Vælg et brugernavn for at kunne chatte',
            'F14': 'er også i dette rum.',
            'F140': 'Brugernavnet er optaget',
            'F141': 'Brugernavnet er ikke validt',
            'F142': 'Tilfældig',
            'F143': 'er nu tilkaldt',
            'F144': 'Vælg en admin',
            'F145': 'Der er desværre ingen admins online. Du kan prøve at vente på én eller henvende dig til vores kundeservice.',
            'F146': 'Chat med en admin',
            'F147': 'Hjælp',
            'F148': 'Online venner',
            'F15': 'Vis chat:',
            'F16': 'Du kan skjule chatten ved at klikke på knappen.',
            'F17': 'Skjul',
            'F18': 'Vis andre brugeres tilstedeværelse:',
            'F19': 'Kun venner',
            'F20': 'Alle',
            'F21': 'Ingen',
            'F22': 'Skriftstørrelse:',
            'F23': 'Skrifttykkelse:',
            'F24': 'Brugere',
            'F25': 'Venner',
            'F26': 'Kick',
            'F28': 'Ban',
            'F29': 'Chat ikon:',
            'F30': 'Vælg andet chat ikon, ved at klikke på det ønskede billede.',
            'F31': 'Giv en kort begrundelse',
            'F32': 'Adminfunktioner:',
            'F33': 'Skift',
            'F34': 'Vis rang:',
            'F35': 'Ja',
            'F36': 'Nej',
            'F37': 'rum',
            'F38': 'Chat ikon',
            'F39': 'Tilbage',
            'F40': 'Lille',
            'F41': 'Normal',
            'F42': 'Stor',
            'F43': 'Fed',
            'F44': 'Du har sendt for mange beskeder lige efter hinanden. Derfor er du blokeret fra chatten i 10 sekunder.',
            'F45': 'Du kan nu skrive i chatten igen.',
            'F46': 'Vis stigning i rang:',
            'F47': 'Vis smileys',
            'F48': 'Få 5% poletter i sidegevinst!',
            'F49': 'Rummet er fyldt. Du bliver flyttet til næste ledige rum.',
            'F50': 'Vent venligst...',
            'F51': 'Sidegevinst udbetalt',
            'F52': 'Admins',
            'F53': 'Dine venner',
            'F54': 'siger',
            'F55': 'Du er banned',
            'F56': 'En nyere version af chatten er tilgængelig',
            'F57': 'Opdatér',
            'F58': 'Send direkte besked',
            'F59': 'Se profil',
            'F60': 'Gør til ven',
            'F61': 'Ignorér',
            'F62': 'Fjern ignorér',
            'F63': 'Blokér',
            'F64': 'Mit chat ikon:',
            'F65': 'Skriftsstørrelse:',
            'F66': 'Venners tilstedeværelse',
            'F67': 'Alles tilstedeværelse',
            'F68': 'Venners beskeder med fed skrift',
            'F69': 'Markering, når mit navn nævnes',
            'F70': 'Smileys',
            'F71': 'Vis rang efter navn hvis muligt',
            'F72': 'Rang beskeder',
            'F73': 'Chat ikon før brugernavn',
            'F74': 'Mørk baggrund',
            'F75': 'Fed skriftstykkelse',
            'F76': 'Sendknap',
            'F77': 'Stort indtastningsfelt',
            'F78': 'Nulstil indstillinger',
            'F79': 'Skjul chatten',
            'F80': 'Sæt flueben, for at vise:',
            'F81': 'Mute',
            'F82': 'Du er muted. Dit mute fjernes automatisk.',
            'F83': 'Direkte beskeder',
            'F84': 'Venneliste',
            'F85': 'Du er nu i',
            'F86': 'lige nu',
            'F87': 'et minut siden',
            'F88': 'XX minutter siden',
            'F89': 'en time siden',
            'F90': 'XX timer siden',
            'F91': 'en dag siden',
            'F92': 'XX dage siden',
            'F93': 'Emblemer, rating, rang og udfordringer',
            'F94': 'Animationer',
            'F95': 'Luk',
            'F96': 'Rediger',
            'F97': 'Kun store gevinster',
            'F98': 'Brugere',
            'F99': 'Chatrum',
            'F150': 'Anmeld',
            'F151': 'For at kunne chatte, skal du lige vælge et <b>brugernavn</b> og et <b>kodeord</b>, så du kan få en rigtig bruger :)<br><br><div class="text-center"><a class="btn btn-primary pulsate" target="_blank" href="/mig/rediger/profil">Vælg brugernavn her</a></div><br><br>Husk at gemme og genindlæse spillet når du har gjort det!'
        };

        this.language['de-DE'] = {
            'F01': 'Dies ist ein Betatest',
            'F02': 'Nachricht eingeben...',
            'F03': 'Um die Nachricht zu versenden drücken Sie auf ENTER',
            'F04': 'Die Verbindung wurde unterbrochen<br> Bitte warten.',
            'F05': 'Letzte Nachricht empfangen:',
            'F06': 'Schreibt',
            'F07': 'ist in den Raum gekommen',
            'F08': 'hat den Raum verlassen',
            'F09': 'Andere Spieler',
            'F10': 'Räume',
            'F100': 'Alle Freunde anzeigen',
            'F101': 'Suche in der Freundesliste',
            'F102': 'Keine neuen Nachrichten',
            'F103': 'Drücken Sie ENTER um auszusuchen',
            'F104': 'Empfänger wählen',
            'F105': 'Gestern',
            'F106': 'Senden',
            'F107': 'Uhr.',
            'F108': 'Neue Nachricht',
            'F109': 'Sind Sie sicher?',
            'F11': 'Einstellungen',
            'F110': 'Ok',
            'F111': 'Zurück',
            'F112': 'Suchen',
            'F113': 'Chat mit XX starten',
            'F114': 'Löschen',
            'F115': 'Benachrichtigung',
            'F116': 'Gratulieren Sie',
            'F117': 'Herzlichen Glückwunsch! :-D',
            'F118': 'Herzlichen Glückwunsch und danke! :-D',
            'F119': 'Keine neuen Benachrichtigungen',
            'F12': 'Ihr Freund/in',
            'F120': 'ist nicht online.',
            'F121': 'Achtung! Das Spiel öffnet sich in einem neuen Fenster.',
            'F122': 'Möchten Sie diese Nachrichten löschen?',
            'F123': 'Töne im Chat',
            'F124': 'Wie lautet der Raumname?',
            'F125': 'Laden Sie andere Benutzer ein indem Sie die Benutzernamen eingeben, Leerzeichen nicht vergessen',
            'F126': 'Admin rufen',
            'F127': 'Laden Sie andere in diesem Raum ein',
            'F128': 'Ein Admin wurde gerufen',
            'F129': 'Fehler bei der Eingabe. Bitte versuchen Sie es wieder.',
            'F13': 'und',
            'F130': 'Laden Sie sich in den Raum ein. ',
            'F131': 'Gruppenchat erstellen',
            'F132': 'Hier wird ein Admin benötigt:',
            'F133': 'erstellt von',
            'F134': 'Sie haben möglicherweise Probleme mit Ihrer Verbindung. Der Grund dafür kann Malware o.ä. sein. Bitte kontaktieren Sie den Kundendienst, wenn Sie Hilfe benötigen. ',
            'F135': 'Weiter zum Raum?',
            'F136': 'Chat mit XX Starten?',
            'F137': '',
            'F138': 'ist nun aufgefordert',
            'F139': '',
            'F14': 'ist ebenfalls im Raum',
            'F140': 'Der Benutzername ist besetzt',
            'F141': 'Der Benutzername ist nicht gültig',
            'F142': 'Zufälliger Admin',
            'F143': 'wurde gerufen',
            'F144': 'Admin auswählen',
            'F145': 'Es ist leider kein Admin online. Sie können entweder warten oder sich an den Kundendienst wenden. ',
            'F146': 'Mit Admin chatten',
            'F147': 'Hilfe',
            'F148': 'Online Freunde',
            'F15': 'Chat anzeigen: ',
            'F16': 'Sie können den Chat verbergen indem Sie den Button anklicken',
            'F17': 'Verbergen',
            'F18': 'Andere User anzeigen:',
            'F19': 'Nur Freunde',
            'F20': 'Alle',
            'F21': 'Keine',
            'F22': 'Schriftgröße:',
            'F23': 'Schriftbreite:',
            'F24': 'Benutzer',
            'F25': 'Freunde',
            'F26': 'Kick',
            'F28': 'Ban',
            'F29': 'Chat Symbol:',
            'F30': 'Wählen Sie ein anderes Bild indem Sie auf das gewünschte Chat Symbol klicken.',
            'F31': 'Kurze Beschreibung',
            'F32': 'Adminfunktionen:',
            'F33': 'Ändern',
            'F34': 'Rang anzeigen:',
            'F35': 'Ja',
            'F36': 'Nej',
            'F37': 'Raum',
            'F38': 'Chat Symbol',
            'F39': 'Zurück',
            'F40': 'Klein',
            'F41': 'Normal',
            'F42': 'Gross',
            'F43': 'Fett',
            'F44': 'Sie haben zu viele Nachrichten nacheinander verschickt. Daher wurden Sie für 10 Sekunden im Chat gesperrt. ',
            'F45': 'Sie können wieder im Chat schreiben.',
            'F46': 'Rangsteigerung anzeigen:',
            'F47': 'Smileys anzeigen',
            'F48': 'Erhalten Sie 5% Jetons als Nebengevinn',
            'F49': 'Der Raum ist voll. Sie werden in den nächsten freien Raum weitergeleitet. ',
            'F50': 'Bitte warten.....',
            'F51': 'Nebengewinn ausgezahlt',
            'F52': 'Admins',
            'F53': 'Ihre Freunde',
            'F54': 'sagen',
            'F55': 'Sie wurde gesperrt',
            'F56': 'Eine neue Chat Version ist jetzt zugänglich',
            'F57': 'Neu Einlesen',
            'F58': 'Direkt Nachricht schicken',
            'F59': 'Profil ansehen',
            'F60': 'Als Freund hinzufügen',
            'F61': 'Ignorieren',
            'F62': 'Ignorieren entfernen',
            'F63': 'Blockieren',
            'F64': 'Mein Chat Symbol:',
            'F65': 'Schriftgrösse:',
            'F66': 'Freunde online',
            'F67': 'Alle anzeigen',
            'F68': 'Nachricht von Freunden fett markieren',
            'F69': 'Markieren, wenn mein Name erwähnt wird',
            'F70': 'Smileys',
            'F71': 'Rang nach Benutzernamen',
            'F72': 'Rang Benachrichtigungen',
            'F73': 'Chat Symbol vor dem Benutzernamen',
            'F74': 'Dunkler Hintergrund',
            'F75': 'Fette Schriftart',
            'F76': 'Senden Button',
            'F77': 'Grosses Eingabefeld',
            'F78': 'Zurücksetzten',
            'F79': 'Chat verbergen',
            'F80': 'Haken setzten wenn: ',
            'F81': 'Mute',
            'F82': 'Sie wurden gemutet. Ihr mute wird automatisch.',
            'F83': 'Direkt Nachrichten',
            'F84': 'Freundesliste',
            'F85': 'Sie befinden sich jetzt in',
            'F86': 'jetzt',
            'F87': 'seit einer Minute',
            'F88': 'XX Minuten her',
            'F89': 'vor einer Stunde',
            'F90': 'XX Stunden her',
            'F91': 'einen Tag her',
            'F92': 'XX Tage her',
            'F93': 'Abzeichen, Rating, Rang und Herausforderungen',
            'F94': 'Animationen',
            'F95': 'Schliessen',
            'F96': 'Ändern',
            'F97': 'Nur grosse Gewinne',
            'F98': 'Benutzer',
            'F99': 'Chatraum',
            'F150': 'Melden',
            'F151': 'Um zu chatten, musst du einen <b>Benutzernamen</b> und ein <b>Passwort</b> wählen, damit du einen richtigen Benutzer bekommst :)<br><br><div class="text-center"><a class="btn btn-primary pulsate" target="_blank" href="/ich/bearbeiten/profil">Wählen Sie Ihren Benutzernamen</a></div><br><br>Denken Sie daran, das Spiel zu speichern und neu zu laden, wenn Sie das getan haben!'
        };
        this.language['en-GB'] = {
            'F01': 'This is a beta version',
            'F02': 'Write message here...',
            'F03': 'Press ENTER to send message',
            'F04': 'Disconnected<br>\nPlease wait.',
            'F05': 'Last message received:',
            'F06': 'writing a message',
            'F07': 'came into the room',
            'F08': 'left the room',
            'F09': 'User list',
            'F10': 'Room list',
            'F100': 'View all friends',
            'F101': 'Search in friends list',
            'F102': 'Conversation list empty',
            'F103': 'Press ENTER to select',
            'F104': 'Select recipient',
            'F105': 'Yesterday',
            'F106': 'Send',
            'F107': 'at',
            'F108': 'New messages',
            'F109': 'Are you sure?',
            'F11': 'Settings',
            'F110': 'Ok',
            'F111': 'Cancel',
            'F112': 'Search',
            'F113': 'Start the conversation with XX here',
            'F114': 'Delete',
            'F115': 'Notifications',
            'F116': 'Congratulate!',
            'F117': 'Congratulations! :-D',
            'F118': 'Congratulations and thanks! :-D',
            'F119': 'The notification list is empty',
            'F12': 'Your friend',
            'F120': 'is not online',
            'F121': 'Note! The game will open in this game window',
            'F122': 'Do you want to delete this messages?',
            'F123': 'Sounds in the chat',
            'F124': 'What should the room name be?',
            'F125': 'Invite other users by entering their usernames, separated by spaces',
            'F126': 'Call admin',
            'F127': 'Invite others to this room',
            'F128': 'An admin has been called',
            'F129': 'There are errors in the entry. Try again.',
            'F13': 'and',
            'F130': 'invites you to this chat room',
            'F131': 'Create a group chat',
            'F132': 'An admin is needed in',
            'F133': 'created by you',
            'F134': 'You may have problems with your connection, which can be caused by malware, or the like. Malware is a variety of forms of hostile or intrusive software and other malicious programs. Contact Customer Service if you need help to remove it.',
            'F135': 'Go to this room?',
            'F136': 'Start chat with XX?',
            'F137': 'test',
            'F138': 'is now invited',
            'F139': 'Choose a username in order to chat',
            'F14': 'is also in this room.',
            'F140': 'The username is taken',
            'F141': 'The username is not valid',
            'F142': 'Random',
            'F143': 'has been called',
            'F144': 'Select an admin',
            'F145': 'There are no admins online at the moment. Please wait or contact our customer service.',
            'F146': 'Chat with admin',
            'F147': 'Help',
            'F148': 'Online friends',
            'F15': 'Show chat:',
            'F16': 'You can hide the chat by clicking the button.',
            'F17': 'Hide',
            'F18': 'View other users\' presence:',
            'F19': 'Friends only',
            'F20': 'All',
            'F21': 'None',
            'F22': 'Font size:',
            'F23': 'Font thickness:',
            'F24': 'Users',
            'F25': 'Friends',
            'F26': 'Kick',
            'F28': 'Ban',
            'F29': 'Chat icon:',
            'F30': 'Choose a different chat icon by clicking on the desired image.',
            'F31': 'Give a brief explanation',
            'F32': 'Admin features:',
            'F33': 'Change',
            'F34': 'Show rank:',
            'F35': 'Yes',
            'F36': 'No',
            'F37': 'room',
            'F38': 'Chat icon',
            'F39': 'Back',
            'F40': 'Small',
            'F41': 'Normal',
            'F42': 'Large',
            'F43': 'Bold',
            'F44': 'You have sent too many messages in a row. Therefore, you are blocked from chat for 10 seconds.',
            'F45': 'You can now type in the chat again.',
            'F46': 'Show rise in rank:',
            'F47': 'Show smileys',
            'F48': 'Get 5% tokens in added bonus!',
            'F49': 'The room is full. You will be moved to the next available room.',
            'F50': 'Please wait...',
            'F51': 'Added bonus paid',
            'F52': 'Admins',
            'F53': 'Your friends',
            'F54': 'says',
            'F55': 'You are banned',
            'F56': 'A newer version of the chat is available.',
            'F57': 'Update',
            'F58': 'Send direct message',
            'F59': 'View profile',
            'F60': 'Add as friend',
            'F61': 'Ignore',
            'F62': 'Remove ignore',
            'F63': 'Block',
            'F64': 'My chat icon:',
            'F65': 'Font size:',
            'F66': 'Friends\' presence',
            'F67': 'Everyone\'s presence',
            'F68': 'Friends\' messages in bold',
            'F69': 'Marking when my name is mentioned',
            'F70': 'Smileys',
            'F71': 'Rank after username',
            'F72': 'Rank messages',
            'F73': 'Chat icon before username',
            'F74': 'Dark background',
            'F75': 'Bold thickness',
            'F76': 'Send button',
            'F77': 'Large entry field',
            'F78': 'Reset settings',
            'F79': 'Hide chat',
            'F80': 'Tick ​​to show:',
            'F81': 'Mute',
            'F82': 'You are muted. Your mute is removed automatically.',
            'F83': 'Direct messages',
            'F84': 'Friend list',
            'F85': 'You are now in',
            'F86': 'right now',
            'F87': 'one minute ago',
            'F88': 'XX minutes ago',
            'F89': 'one hour ago',
            'F90': 'XX hours ago',
            'F91': 'one day ago',
            'F92': 'XX days ago',
            'F93': 'Badges, rating, rank and challenges',
            'F94': 'Animations',
            'F95': 'Close',
            'F96': 'Edit',
            'F97': 'Only big prizes',
            'F98': 'Users',
            'F99': 'Chat room',
            'F150': 'Report',
            'F151': 'In order to chat, you need to choose a <b>username</b> and a <b>password</b> so you can get a real user :)<br><br><div class="text-center"><a class="btn btn-primary pulsate" target="_blank" href="/me/edit/profile">Choose username here</a></div><br><br>Remember to save and reload the game once you\'ve done that!'
        };
        this.language['en-US'] = {
            'F01': 'This is a beta version',
            'F02': 'Write message here...',
            'F03': 'Press ENTER to send message',
            'F04': 'Disconnected<br>\nPlease wait.',
            'F05': 'Last message received:',
            'F06': 'writing a message',
            'F07': 'came into the room',
            'F08': 'left the room',
            'F09': 'User list',
            'F10': 'Room list',
            'F100': 'View all friends',
            'F101': 'Search in friends list',
            'F102': 'Conversation list empty',
            'F103': 'Press ENTER to select',
            'F104': 'Select recipient',
            'F105': 'Yesterday',
            'F106': 'Send',
            'F107': 'at',
            'F108': 'New messages',
            'F109': 'Are you sure?',
            'F11': 'Settings',
            'F110': 'Ok',
            'F111': 'Cancel',
            'F112': 'Search',
            'F113': 'Start the conversation with XX here',
            'F114': 'Delete',
            'F115': 'Notifications',
            'F116': 'Congratulate!',
            'F117': 'Congratulations! :-D',
            'F118': 'Congratulations and thanks! :-D',
            'F119': 'The notification list is empty',
            'F12': 'Your friend',
            'F120': 'is not online',
            'F121': 'Note! The game will open in this game window',
            'F122': 'Do you want to delete this messages?',
            'F123': 'Sounds in the chat',
            'F124': 'What should the room name be?',
            'F125': 'Invite other users by entering their usernames, separated by spaces',
            'F126': 'Call admin',
            'F127': 'Invite others to this room',
            'F128': 'An admin has been called',
            'F129': 'There are errors in the entry. Try again.',
            'F13': 'and',
            'F130': 'invites you to this chat room',
            'F131': 'Create a group chat',
            'F132': 'An admin is needed in',
            'F133': 'created by you',
            'F134': 'You may have problems with your connection, which can be caused by malware, or the like. Malware is a variety of forms of hostile or intrusive software and other malicious programs. Contact Customer Service if you need help to remove it.',
            'F135': 'Go to this room?',
            'F136': 'Start chat with XX?',
            'F137': 'test',
            'F138': 'is now invited',
            'F139': 'Choose a username in order to chat',
            'F14': 'is also in this room.',
            'F140': 'The username is taken',
            'F141': 'The username is not valid',
            'F142': 'Random',
            'F143': 'has been called',
            'F144': 'Select an admin',
            'F145': 'There are no admins online at the moment. Please wait or contact our customer service.',
            'F146': 'Chat with admin',
            'F147': 'Help',
            'F148': 'Online friends',
            'F15': 'Show chat:',
            'F16': 'You can hide the chat by clicking the button.',
            'F17': 'Hide',
            'F18': 'View other users\' presence:',
            'F19': 'Friends only',
            'F20': 'All',
            'F21': 'None',
            'F22': 'Font size:',
            'F23': 'Font thickness:',
            'F24': 'Users',
            'F25': 'Friends',
            'F26': 'Kick',
            'F28': 'Ban',
            'F29': 'Chat icon:',
            'F30': 'Choose a different chat icon by clicking on the desired image.',
            'F31': 'Give a brief explanation',
            'F32': 'Admin features:',
            'F33': 'Change',
            'F34': 'Show rank:',
            'F35': 'Yes',
            'F36': 'No',
            'F37': 'room',
            'F38': 'Chat icon',
            'F39': 'Back',
            'F40': 'Small',
            'F41': 'Normal',
            'F42': 'Large',
            'F43': 'Bold',
            'F44': 'You have sent too many messages in a row. Therefore, you are blocked from chat for 10 seconds.',
            'F45': 'You can now type in the chat again.',
            'F46': 'Show rise in rank:',
            'F47': 'Show smileys',
            'F48': 'Get 5% tokens in added bonus!',
            'F49': 'The room is full. You will be moved to the next available room.',
            'F50': 'Please wait...',
            'F51': 'Added bonus paid',
            'F52': 'Admins',
            'F53': 'Your friends',
            'F54': 'says',
            'F55': 'You are banned',
            'F56': 'A newer version of the chat is available.',
            'F57': 'Update',
            'F58': 'Send direct message',
            'F59': 'View profile',
            'F60': 'Add as friend',
            'F61': 'Ignore',
            'F62': 'Remove ignore',
            'F63': 'Block',
            'F64': 'My chat icon:',
            'F65': 'Font size:',
            'F66': 'Friends\' presence',
            'F67': 'Everyone\'s presence',
            'F68': 'Friends\' messages in bold',
            'F69': 'Marking when my name is mentioned',
            'F70': 'Smileys',
            'F71': 'Rank after username',
            'F72': 'Rank messages',
            'F73': 'Chat icon before username',
            'F74': 'Dark background',
            'F75': 'Bold thickness',
            'F76': 'Send button',
            'F77': 'Large entry field',
            'F78': 'Reset settings',
            'F79': 'Hide chat',
            'F80': 'Tick ​​to show:',
            'F81': 'Mute',
            'F82': 'You are muted. Your mute is removed automatically.',
            'F83': 'Direct messages',
            'F84': 'Friend list',
            'F85': 'You are now in',
            'F86': 'right now',
            'F87': 'one minute ago',
            'F88': 'XX minutes ago',
            'F89': 'one hour ago',
            'F90': 'XX hours ago',
            'F91': 'one day ago',
            'F92': 'XX days ago',
            'F93': 'Badges, rating, rank and challenges',
            'F94': 'Animations',
            'F95': 'Close',
            'F96': 'Edit',
            'F97': 'Only big prizes',
            'F98': 'Users',
            'F99': 'Chat room',
            'F150': 'Report',
            'F151': 'In order to chat, you need to choose a <b>username</b> and a <b>password</b> so you can get a real user :)<br><br><div class="text-center"><a class="btn btn-primary pulsate" target="_blank" href="/me/edit/profile">Choose username here</a></div><br><br>Remember to save and reload the game once you\'ve done that!'
        };

        this.language['nl-NL'] = {
            'F01': 'Dit is een betaversie',
            'F02': 'Schrijf uw bericht hier...',
            'F03': 'Druk op ENTER om het bericht te verzenden',
            'F04': 'De verbinding is verbroken<br>\nEen ogenblik geduld.',
            'F05': 'Laatste bericht ontvangen:',
            'F06': 'schrijft een bericht',
            'F07': 'komt de chatruimte binnen',
            'F08': 'heeft de chatruimte verlaten',
            'F09': 'Gebruikerslijst',
            'F10': 'Kamerlijst',
            'F100': 'Toon alle vrienden',
            'F101': 'Zoek in vriendenlijst',
            'F102': 'Gesprekslijst leeg',
            'F103': 'Druk op ENTER om te selecteren',
            'F104': 'Selecteer ontvanger',
            'F105': 'Gisteren',
            'F106': 'Stuur',
            'F107': 'om',
            'F108': 'Nieuwe berichten',
            'F109': 'Bent u zeker?',
            'F11': 'Instellingen',
            'F110': 'Ok',
            'F111': 'Annuleer',
            'F112': 'Zoek',
            'F113': 'Begin het gesprek met XX hier',
            'F114': 'Verwijder',
            'F115': 'Notificaties',
            'F116': 'Feliciteer!',
            'F117': 'Gefeliciteerd! :-D',
            'F118': 'Gefeliciteerd en bedankt! :-D',
            'F119': 'De notificaties zijn leeg',
            'F12': 'Uw vriend',
            'F120': 'is niet online',
            'F121': 'Opgelet! Het spel zal openen in dit spelvenster',
            'F122': 'Wilt u dit bericht verwijderen?',
            'F123': 'Geluid in de chat',
            'F124': 'Wat moet de naam van de kamer zijn?',
            'F125': 'Nodig andere gebruikers uit door hun gebruikersnamen in te voeren gescheiden door spaties',
            'F126': 'Roep admin',
            'F127': 'Nodig anderen uit in deze kamer',
            'F128': 'Een admin is opgeroepen',
            'F129': 'Er zijn fouten bij het invoeren. Probeer opnieuw.',
            'F13': 'en',
            'F130': 'nodigt u uit in deze chatruimte.',
            'F131': 'Maak een groepchat aan',
            'F132': 'Er is een admin nodig in',
            'F133': 'gemaakt door u',
            'F134': 'U heeft mogelijk problemen met uw verbinding, dit kan veroorzaakt worden door malware. Malware zijn verschillende vormen van vijandige en kwaadaardige software en programma´s op uw computer. Gelieve de klantenservice te contacteren als u hulp nodig heeft om deze te verwijderen.',
            'F135': 'Ga naar deze chatruimte?',
            'F136': 'Beginnen chatten met XX?',
            'F137': '',
            'F138': 'is nu uitgenodigd',
            'F139': '',
            'F14': 'is ook in deze kamer.',
            'F140': '',
            'F141': '',
            'F142': 'Toevallig',
            'F143': 'heet nu',
            'F144': 'Selecteer een admin',
            'F145': 'Er zijn helaas geen admins online op dit moment. Een ogenblik geduld of neem contact op met onze klantenservice.',
            'F146': 'Chat met admin',
            'F147': 'Help',
            'F148': 'online vrienden',
            'F15': 'Toon chat:',
            'F16': 'U kunt de chat verbergen door op de knop te klikken.',
            'F17': 'Verberg',
            'F18': 'Kijk naar andere gebruikers aanwezigheid:',
            'F19': 'Enkel vrienden',
            'F20': 'Alle',
            'F21': 'Geen',
            'F22': 'Lettertypegrootte:',
            'F23': 'Lettertypedikte:',
            'F24': 'Gebruikers',
            'F25': 'Vrienden',
            'F26': 'Kick',
            'F28': 'Ban',
            'F29': 'Chat icoon:',
            'F30': 'Kies een ander chaticoon door op de gewenste afbeelding te klikken.',
            'F31': 'Geef een korte uitleg',
            'F32': 'Adminfuncties:',
            'F33': 'Verander',
            'F34': 'Toon rang:',
            'F35': 'Ja',
            'F36': 'Neen',
            'F37': 'chatruimte',
            'F38': 'Chat icoon',
            'F39': 'Terug',
            'F40': 'Klein',
            'F41': 'Normaal',
            'F42': 'Groot',
            'F43': 'Vet',
            'F44': 'U heeft teveel berichten vlak na elkaar verzonden, u bent daarom 10 seconden geblokkeerd van de chat.',
            'F45': 'U kunt nu terug in de chat schrijven.',
            'F46': 'Toon stijging in rang:',
            'F47': 'Toon smileys',
            'F48': 'Krijg 5% tokens als premiedeling!',
            'F49': 'De chatruimte is vol. U wordt verplaatst naar de volgende beschikbare chatruimte.',
            'F50': 'Even geduld aub...',
            'F51': 'Toegevoegde bonus betaald',
            'F52': 'Admins',
            'F53': 'Uw vrienden',
            'F54': 'zegt',
            'F55': 'U bent gebanned',
            'F56': 'Een nieuwere versie van de chat is beschikbaar',
            'F57': 'Update',
            'F58': 'Stuur direct bericht',
            'F59': 'Bekijk profiel',
            'F60': 'Toevoegen als vriend',
            'F61': 'Negeren',
            'F62': 'Verwijder negeren',
            'F63': 'Blokkeer',
            'F64': 'Nieuw chaticoon:',
            'F65': 'Lettertypegrootte:',
            'F66': 'Aanwezigheid van vrienden',
            'F67': 'Aanwezigheid van iedereen',
            'F68': 'Berichten van vrienden in het vet.',
            'F69': 'Markeer als mijn naam vernoemd wordt.',
            'F70': 'Smileys.',
            'F71': 'Rang volgens gebruikersnaam.',
            'F72': 'Rang berichten.',
            'F73': 'Chat icoon voor gebruikersnaam.',
            'F74': 'Donkere achtergrond.',
            'F75': 'Vette letterdikte.',
            'F76': 'Verzendknop.',
            'F77': 'Groot invoerveld.',
            'F78': 'Instellingen resetten',
            'F79': 'Chat verbergen',
            'F80': 'Vink aan om weer te geven:',
            'F81': 'Dempen',
            'F82': 'U ben gedempt, uw demping wordt automatisch verwijderd.',
            'F83': 'Directe berichten',
            'F84': 'Vriendenlijst',
            'F85': 'U bent er nu in',
            'F86': 'op dit moment',
            'F87': 'één minuut geleden',
            'F88': 'XX minuten geleden',
            'F89': 'een uur geleden',
            'F90': 'XX uur geleden',
            'F91': 'één dag geleden',
            'F92': 'XX dagen geleden',
            'F93': 'Emblemen, rating, rank en uitdagingen',
            'F94': 'Animaties',
            'F95': 'Sluit',
            'F96': 'Wijzig',
            'F97': 'Enkel grote prijzen',
            'F98': 'Gebruikers',
            'F99': 'Chatruimte',
            'F150': 'Melden',
            'F151': 'Om te kunnen chatten moet je eerst een profiel aanmaken met een <b>gebruikersnaam</b> en een <b>wachtwoord</b> kiezen zodat je een echte gebruiker krijgt :)<br><br><div class="text-center"><a class="btn btn-primary pulsate" target="_blank" href="/ich/uitgeven/profiel">Kies haar gebruikersnaam</a></div><br><br>Vergeet niet het spel op te slaan en opnieuw te laden als je dat hebt gedaan!'
        };

        this.language['fr-FR'] = {
            'F01': 'Version bêta',
            'F02': 'Écrire un message ici...',
            'F03': 'Appuyez sur ENTER pour envoyer un message',
            'F04': 'Déconnecté<br>\nS\'il vous plaît attendre.',
            'F05': 'Dernier message reçu',
            'F06': 'en train d\'écrire un message',
            'F07': 'entra dans la salle',
            'F08': 'quitta la salle',
            'F09': 'Liste des utilisateurs',
            'F10': 'Liste des salles',
            'F100': 'Voir tous les amis',
            'F101': 'Rechercher dans la liste d\'amis',
            'F102': 'La liste de conversation est vide',
            'F103': 'Appuyez sur ENTER pour sélectionner',
            'F104': 'Sélectionnr destinataire',
            'F105': 'Hier',
            'F106': 'Envoyer',
            'F107': 'h.',
            'F108': 'Nouveaux messages',
            'F109': 'Êtes-vous sûr?',
            'F11': 'Paramètres',
            'F110': 'Ok',
            'F111': 'Annuler',
            'F112': 'Rechercher',
            'F113': 'Commencer la conversation avec XX ici',
            'F114': 'Supprimer',
            'F115': 'Notifications',
            'F116': 'Félicitez!',
            'F117': 'Félicitations! :-D',
            'F118': 'Félicitations et merci! :-D',
            'F119': 'La liste de notification est vide',
            'F12': 'Votre ami',
            'F120': 'est pas en ligne',
            'F121': 'Remarquer! Les jeu se ouvre dans cette fenêtre de jeu',
            'F122': 'Voulez-vous supprimer ces messages?',
            'F123': 'Sons dans le chat',
            'F124': 'Nom de la salle désiré?',
            'F125': 'Invitez d\'autres utilisateurs en entrant leur pseudos, séparés par des espaces',
            'F126': 'Faire intervenir un modo',
            'F127': 'Inviter autres dans cette salle',
            'F128': 'Un modo a été appelé',
            'F129': 'Il y a des erreurs dans l\'entrée. Réessayer.',
            'F13': 'et',
            'F130': 'vous invite à cette salle',
            'F131': 'Créer un chat en groupe',
            'F132': 'On a besoin d\'un modérateur dans',
            'F133': 'créé par vous',
            'F134': 'Vous pouvez avoir des problèmes avec votre connexion, qui peut être causée par des logiciels malveillants, ou similaire développés dans le but de nuire à un système informatique, sans le consentement de l\'utilisateur infecté. Contactez le service à la clientèle si vous avez besoin d\'aide pour les supprimer.',
            'F135': 'Aller à cette salle?',
            'F136': 'Lancer un chat avec XX?',
            'F137': 'test',
            'F138': 'est maintenant invité',
            'F139': 'Choisir un pseudo pour chatter',
            'F14': 'est aussi dans cette salle.',
            'F140': 'Le pseudo est pris',
            'F141': 'Le pseudo est pas valide',
            'F142': 'Aléatoire',
            'F143': 'a été appelé',
            'F144': 'Choisir un modo',
            'F145': 'Il n\'y aucun modérateur en ligne pour le moment. S\'il vous plaît attendre ou contacter notre service à la clientèle.',
            'F146': 'Parler avec un modo',
            'F147': 'Aide',
            'F148': 'Amis en ligne',
            'F15': 'Afficher le chat:',
            'F16': 'Vous pouvez cacher le chat en cliquant sur le bouton.',
            'F17': 'Cacher',
            'F18': 'Voir la présence d\'autres utilisateurs:',
            'F19': 'Amis uniquement',
            'F20': 'Tous',
            'F21': 'Aucun',
            'F22': 'Taille de la police:',
            'F23': 'Epaisseur de la police:',
            'F24': 'Utilisateurs',
            'F25': 'Amis',
            'F26': 'Kick',
            'F28': 'Exclure',
            'F29': 'Icône de chat:',
            'F30': 'Choisissez une autre icône de chat en cliquant sur l\'image désirée.',
            'F31': 'Donner une brève explication',
            'F32': 'Fonctions des modos:',
            'F33': 'Changer',
            'F34': 'Afficher rang:',
            'F35': 'Oui',
            'F36': 'Non',
            'F37': 'salle',
            'F38': 'Icône de chat',
            'F39': 'Retour',
            'F40': 'Petit',
            'F41': 'Normal',
            'F42': 'Grand',
            'F43': 'Gras',
            'F44': 'Vous avez envoyé trop de messages dans une rangée. Par conséquent, vous êtes bloqué pendant 10 secondes.',
            'F45': 'Vous pouvez maintenant réécrire.',
            'F46': 'Afficher hausse dans le rang:',
            'F47': 'Afficher smileys',
            'F48': '',
            'F49': 'La salle est remplie. Vous serez déplacé à l\'autre chambre disponible.',
            'F50': 'Attendre s\'il vous plaît...',
            'F51': 'Bonus ajouté payé',
            'F52': 'Modos',
            'F53': 'Vos amis',
            'F54': 'dit',
            'F55': 'Vous êtes exclu',
            'F56': 'Une nouvelle version du chat est disponible.',
            'F57': 'Mettre à jour',
            'F58': 'Envoyer un message directe',
            'F59': 'Voir le profil',
            'F60': 'Ajouter comme ami',
            'F61': 'Ignorer',
            'F62': 'Retirer ignorer',
            'F63': 'Bloquer',
            'F64': 'Mon icône de chat:',
            'F65': 'Taille de la police:',
            'F66': 'Présence de vos amis',
            'F67': 'Présence de tout le monde',
            'F68': 'Messages d\'amis en gras',
            'F69': 'Marquage quand mon nom est mentionné',
            'F70': 'Smileys',
            'F71': 'Rang après le pseudo',
            'F72': 'Messages de rang',
            'F73': 'Icône de chat avant le pseudo',
            'F74': 'Fond foncé',
            'F75': 'Épaisseur gras',
            'F76': 'Bouton envoyer',
            'F77': 'Grand champ de saisie',
            'F78': 'Réinitialiser les paramètres',
            'F79': 'Cacher le chat',
            'F80': 'Cocher pour afficher:',
            'F81': 'Muet',
            'F82': 'Vous êtes en muet. Votre silence sera enlevé automatiquement.',
            'F83': 'Messages directs',
            'F84': 'Liste d\'amis',
            'F85': 'Vous êtes maintenant dans',
            'F86': 'maintenant',
            'F87': 'il y a une minute',
            'F88': 'il y a XX minutes',
            'F89': 'il y a une heure',
            'F90': 'il y a XX heures',
            'F91': 'il y a un jour',
            'F92': 'il y a XX jours',
            'F93': 'Badges, points, rang et challenges',
            'F94': 'Animations',
            'F95': 'Fermer',
            'F96': 'Éditer',
            'F97': 'Seulement les grands prix',
            'F98': 'Utilisateurs',
            'F99': 'Salle de chat',
            'F150': 'Rapporter',
            'F151': 'Pour pouvoir chatter, vous devez choisir un <b>nom d\'utilisateur</b> et un <b>mot de passe</b> afin de créer un vrai utilisateur :)<br><br><div class="text-center"><a class="btn btn-primary pulsate" target="_blank" href="/utili/editer/profil">Choisir son nom d\'utilisateur</a></div><br><br>N\'oubliez pas de sauvegarder et de recharger le jeu une fois que vous avez fait cela !'
        };

        this.lang = this.language[locale];
    }

    getText(field) {
        return this.lang[field];
    }

    getAll() {
        return this.lang;
    }
}